export const initialAbility = [
  {
    action: 'read',
    subject: 'all',
  },
]

export const _ = undefined
